import React, {useEffect, useState} from 'react'
import ChangeIncrementSvg from '../ChangeIncrementSvg'
import moment from "moment-timezone";

import "./styles.css";

// Set default timezone
moment.tz.setDefault("America/New_York");

const SelectQuantity = ({ appointment, color, updateQuantity, handleSetView, backButton = false, backButtonAction, shared = {spots: Infinity, booked_quantity: 1}, addToCart = false, style = {}, showTitle = false}) => {
  const { id, quantity, spots } = appointment
  const [sharedDatedValid, setSharedDatedValid] = useState(true)
  const isMobile = window.innerWidth < 768

  useEffect(() => {
    if (shared.date) {
      const currentTime = moment().format();
      const date = shared.date ? moment(shared.date).format("YYYY-MM-DD") : '';
      const startTime = shared.start_time ? moment(shared.start_time).format("HH:MM:00") : '';
      const orderDate = date ? moment(
        `${date} ${startTime}`
      ).format() : '';
      setSharedDatedValid(moment(currentTime).isBefore(moment(orderDate)))
    }
  }, [shared])
  return (
    <>
    {appointment.title && (
    <div className="ct-modal__quantity">
      {backButton && <div>
        <button className="ct-modal__button" onClick={backButtonAction}>Back</button>
      </div>}
      <div className="ct-modal__quantity--select"  style={{...style}}>
        {showTitle && !isMobile && <span className="ct-modal__quantity--title">Select Your Seats:</span>}
        <div className="ct-modal__quantity--select__change">
          {sharedDatedValid && Number(shared.spots) - Number(shared.booked_quantity) > 0 && (
            <>
            <ChangeIncrementSvg id={id} icon="minus" color={color} width="20px" disabled={Boolean(Number(quantity) <= 1)} updateQuantity={updateQuantity} />
            <input type="number" value={quantity} onChange={(e) => {
              if (Number(e.target.value) <= Number(shared.spots) - Number(shared.booked_quantity)) {
                updateQuantity(id, e.target.value)
              }
              }}
            />
            {shared?.quantity && `/ ${shared.spots - shared.booked_quantity}`}
            <ChangeIncrementSvg id={id} icon="plus" color={color} width="20px" disabled={Boolean(Number(quantity) >= spots || Number(quantity) >= Number(shared.spots) - Number(shared.booked_quantity))} updateQuantity={updateQuantity} />
            </>
          )}
          { !sharedDatedValid && Number(shared.spots) - Number(shared.booked_quantity) > 0 && (
            <p style={{fontSize: 16, fontWeight: '700', color: '#fd6a4f'}}>Workshop date is no longer available.</p>
          )}
          { sharedDatedValid && Number(shared.spots) - Number(shared.booked_quantity) <= 0 && (
            <p style={{fontSize: 16, fontWeight: '700', color: '#fd6a4f'}}>Workshop is fully booked.</p>
          )}
        </div>
        {!addToCart && <button className="ct-modal__button" style={{ marginLeft: '25px' }} onClick={() => handleSetView('confirm', appointment)}>Select</button>}
        {addToCart && sharedDatedValid && Number(shared.spots) - Number(shared.booked_quantity) > 0 && <button className="ct-modal__button" style={{ marginLeft: '25px' }} onClick={() => addToCart()}>Add to cart</button>}
      </div>
    </div>)}
    </>
  )
}

export default SelectQuantity
